<div class="py-3" style="width: 252px;">
    <div class="py-1" cvLocalizedText langSection="Wallboard_Slideout" langKey="Sort_By">Sort by</div>
    <div class="d-flex">
        <select class="form-control columnSortSelector" [(ngModel)]="settingsManager.wallboardColumnSortSettings.ColumnToSort">
            <option *ngFor="let col of columnOptions" [ngValue]="col[1]">{{col[0]}}</option>
        </select>
        <button type="button" class="icon-btn d-flex align-items-center pl-2" (click)="handleSortClick()">
            <svg class="icon-16" [ngSwitch]="settingsManager.wallboardColumnSortSettings.SortAscending">
                <use *ngSwitchCase="true" href="../App_Themes/clearview-default/icons/utility/sort-arrows-up.svg#sort-arrows-up"></use>
                <use *ngSwitchCase="false" href="../App_Themes/clearview-default/icons/utility/sort-arrows-down.svg#sort-arrows-down"></use>
                <use *ngSwitchCase="null" href="../App_Themes/clearview-default/icons/utility/sort-arrows-none.svg#sort-arrows-none"></use>
            </svg>
        </button>
    </div>
</div>
